module.exports = __webpack_public_path__ + "img/error-no-odds.4b737460.svg";